import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import App from '@/app';

if (App.ENV_MODE === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [new VueIntegration({Vue, attachProps: true})],
  });

  window.onerror = function (msg, url, lineNo, columnNo, error) {
    Sentry.captureException(error);
  };
}
